import { Reducer } from 'redux';
import { DownloadAttachmentsState, DownloadAttachmentsTypes } from './types';

const INITIAL_STATE: DownloadAttachmentsState = {
  error: false,
  loading: false,
};

const reducer: Reducer<DownloadAttachmentsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DownloadAttachmentsTypes.LOAD_DOWNLOADATTACHMENTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DownloadAttachmentsTypes.LOAD_DOWNLOADATTACHMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        attachments: [],
      };

    default:
      return state;
  }
};

export default reducer;
